import { addPortNode } from '@/port'
import { h } from '@vue/composition-api'

// @ts-ignore
import Cart from '../components/cart.vue'

export function showCart(data: { id: string; martId: any }) {
  const destroy = addPortNode(
    h(
      {
        data: () => ({
          visible: false,
        }),

        mounted() {
          // @ts-ignore
          this.visible = true
        },

        render() {
          return h(Cart, {
            attrs: {
              id: data.id,
            },
            props: {
              value: this.visible,
              ...data,
            },
            on: {
              input: (visible: boolean) => {
                if (!visible) {
                  // @ts-ignore
                  this.visible = false
                  destroy()
                }
              },
            } as any,
          })
        },
      },
      {
        key: Date.now(),
      },
    ),
  )
  return destroy
}
